import { render } from "./CustomerAdminDoughnutChart.vue?vue&type=template&id=22be9ff4&scoped=true"
import script from "./CustomerAdminDoughnutChart.vue?vue&type=script&lang=js"
export * from "./CustomerAdminDoughnutChart.vue?vue&type=script&lang=js"

import "./CustomerAdminDoughnutChart.vue?vue&type=style&index=0&id=22be9ff4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22be9ff4"]])

export default __exports__